/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Box } from '@mui/material';

const Button = styled.button`
  width: 45px;
  height: 45px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  opacity: ${(props) => (props.isDisabled ? 0.3 : 1)};
`;

const ToolbarButton = ({ onClickHandler, icon, titleText, isDisabled }) => {
  return (
    <Button onClick={onClickHandler} title={titleText} isDisabled={isDisabled}>
      {icon !== undefined && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={icon}
            alt={titleText}
            style={{
              height: '0.9rem',
              width: '0.9rem',
            }}
          />
        </div>
      )}
    </Button>
  );
};

ToolbarButton.propTypes = {
  onClickHandler: PropTypes.func,
  icon: PropTypes.string.isRequired,
  titleText: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
};

ToolbarButton.defaultProps = {
  isDisabled: false,
};

export default ToolbarButton;
